<template>
  <div>
    <div>
      <FormField
        id="businessName"
        label="Raison sociale du magasin"
        labelClass="font-normal"
        name="businessName"
        required
        placeholder="Raison sociale"
        v-model="formData.businessName"
      />
      <FormField
        id="salesChannel"
        label="Nom commercial du magasin"
        labelClass="font-normal"
        name="salesChannel"
        required
        placeholder="Nom commercial"
        v-model="formData.salesChannel"
      />
      <FormField
        id="billingAddress"
        label="Adresse de facturation du magasin"
        labelClass="font-normal"
        name="billingAddress"
        required
        placeholder="Adresse de facturation"
        v-model="formData.billingAddress"
      />
      <LocationField
        id="shippingAddress"
        label="Adresse postale du magasin"
        placeholder="Adresse postale"
        v-model="formData.shippingAddress"
        required
      />
      <Selector
        class="mt-2"
        id="revenue_range"
        label="Revenue range"
        labelClass="font-normal"
        name="revenue_range"
        required
        v-model="formData.revenueRange"
        :options="revenueRangeOptions"
      />
      <Selector
        class="mt-2"
        id="ownership_type"
        label="Type d'exploitation"
        labelClass="font-normal"
        name="ownership_type"
        required
        v-model="formData.ownershipType"
        :options="ownershipTypeOptions"
      />
    </div>
    <div class="mt-4 flex justify-end">
      <GenericButton @click="updateGeneralInformations">
        <span v-if="store[configStatus] == 'pending_validation'">Modifier</span>
        <span v-else>Valider</span>
      </GenericButton>
    </div>
  </div>
</template>

<script>
import { Selector, GenericButton, FormField, LocationField } from "@estaly/ui";
import StoresService from "@/api/services/stores";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["store", "configStatus"],

  components: {
    GenericButton,
    Selector,
    FormField,
    LocationField,
  },

  data() {
    return {
      formData: {
        businessName: this.store.businessName || "",
        salesChannel: this.store.salesChannel || "",
        billingAddress: this.store.billingAddress || this.store.organization.billingAddress || "",
        shippingAddress: this.store.shippingAddress || "",
        revenueRange: this.store.revenueRange || "",
        ownershipType: this.store.ownershipType || "",
      },
    };
  },

  computed: {
    ...mapGetters("store", ["getRevenueRanges", "getOwnershipTypes"]),

    revenueRangeOptions() {
      return this.getRevenueRanges().map((revenueRange) => ({
        value: revenueRange,
        label: this.$t(`organization.revenue_range.${revenueRange}`),
      }));
    },

    ownershipTypeOptions() {
      return this.getOwnershipTypes().map((ownershipType) => ({
        value: ownershipType,
        label: this.$t(`store.ownership_type.${ownershipType}`),
      }));
    },
  },

  emits: ["configurationUpdated"],

  methods: {
    ...mapActions("notifications", ["notify"]),

    async updateGeneralInformations() {
      const storeId = this.store.id;
      const payload = {
        ...this.formData,
      };
      const response = await StoresService.updateGeneralInformations(storeId, payload);
      if (!response?.success) return;

      this.$emit("configurationUpdated");
      this.$emit("stepValidated");
      this.notify({
        category: "simple",
        type: "success",
        title: "Informations mises à jour",
        text: "Les informations générales ont été mises à jour avec succès",
      });
    },
    deduplicate(options) {
      return [...new Map(options.map((option) => [option.value, option])).values()];
    },
  },
  watch: {
    "store.id": {
      immediate: false,
      handler() {
        this.formData = {
          businessName: this.store.businessName || "",
          salesChannel: this.store.salesChannel || "",
          billingAddress: this.store.billingAddress || this.store.organization.billingAddress || "",
          shippingAddress: this.store.shippingAddress || "",
          revenueRange: this.store.revenueRange || "",
        };
      },
    },
  },
};
</script>
